import { displayError, displayWarning } from "../../utils/messageToast";
import { SetupFlow } from "../../apis/apisFlowByAuthorizationRA";
import { displaySuccess } from "../../utils/messageToast";
import { getSkillId } from "../getSkill";
import { getTabId } from "../getTab";

export const saveForm = async (
  setLoadingButtonSave: React.Dispatch<React.SetStateAction<boolean>>,
  form: any,
  authorization: string,
  authorizationRA: string,
  setButtonPublish: React.Dispatch<React.SetStateAction<boolean>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>,
  setIdFormSaved: React.Dispatch<React.SetStateAction<string>>,
  nameForm: string,
  skillIdForm: string,
  tabIdForm: string,
  aliasFormResult: string,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  signOut: () => void
) => {
  setLoadingButtonSave(true);

  if (nameForm === "") {
    displayWarning("Preencha o nome do formulário!");
    return;
  }

  if (skillIdForm === "") {
    displayWarning("Preencha a habilidade!");
    return;
  }

  if (tabIdForm === "") {
    displayWarning("Preencha a tabulação!");
    return;
  }

  if (aliasFormResult === "") {
    displayWarning("Preencha o alias do formulário!");
    return;
  }

  await getSkillId(skillIdForm, authorization, ambient, setSkillName, signOut);

  await getTabId(tabIdForm, authorization, ambient, setTabName, signOut);

  function removeEmptyFields(elements: any): void {
    for (let i = elements.length - 1; i >= 0; i--) {
      const element = elements[i];
      if (element.id === "" || element.name === "") {
        elements.splice(i, 1);
        // displayWarning("Todos os campos vazios removidos!");
      } else if (element.children) {
        removeEmptyFields(element.children);
      }
    }
  }

  function cleanForm(form: any): void {
    removeEmptyFields(form.template.children);
  }

  cleanForm(form);

  try {
    const apiClient = SetupFlow(authorizationRA);
    const response = await apiClient.put(
      `/update-form?ambient=${ambient}`,
      form,
      {
        maxBodyLength: Infinity,
      }
    );

    setIdFormSaved(response.data.form.id);
    setButtonPublish(true);
    setButtonSave(false);
    setLoadingButtonSave(false);
    displaySuccess("Formulário salvo!");
  } catch (error: any) {
    displayError("Erro ao salvar o formulário!");
    return;
  }
};
